<template>
  <div>
    <div id="container" v-if="showPay">
      <form method="post" action="#" id="form1">
        <div class="aspNetHidden">
          <input name="__VIEWSTATE" id="__VIEWSTATE" value="+pG0aFbAagyDeeQ9YK0hur4snqyrV8DmLMgHcyKAZLb71q3tVFhZrndL0ApA7qaTAu14r95Fcl31RPz0rthR+KnMGgtkiCtn+modVwBLQKTGR7lsb/PuYPSVD06LjaHV/kXUQhSSeRkZf2bb+j1VsEBiD2czBxjDnjlvF9lNgnDf0P+YBovjiZhITNAYYPBE66/mLZA4csE9tuUKTseQ+4VFEHA6Lr++lC9s4qaxmSw="
            type="hidden">
        </div>

        <div class="aspNetHidden">

          <input name="__VIEWSTATEGENERATOR" id="__VIEWSTATEGENERATOR" value="8C61547A" type="hidden">
        </div>

        <div class="lu_toper">
          <div class="lu_top">欢迎使用微信付款</div>
        </div>
        <div style="margin-bottom:3px">
          <div class="lu_login">
            <div class="lu_log">
              <img src="/assets/img/login.jpg"></div>
          </div>
          <div class="lu_main">
            <div class="lu_maintop">
              <p>正在使用即时到账交易<span style="color: #3cb034;">[?]</span></p>
              <div>
                <div class="fl"><b id="suit_type"></b><span style="margin-left: 10px; font-size: 12px;">收款方：广州市小弹壳网络科技有限公司</span></div>
                <div class="fr jaige">
                  <span id="total">{{payMoney}}</span>元
                </div>
                <div class="clear"></div>
                <input type="hidden" id="orderid" value="" />
              </div>
            </div>

            <div class="lu_mianer">

              <div class="fl erweima" style="position:relative;">
                <div style="position:absolute; left:0; bottom:-25px; font-size:12px; color:#666; width:190px; text-align:center; text-decoration:underline;">首次使用请下载手机微信</div>
                <img id="Image2" :src="payImg" style="width: 170px; height: 170px;">
                <div class="fl" style="width:20%; margin-top:10px; margin-left:18px;"><img src="/assets/img/sao.jpg"></div>
                <div class="fl" style="width:60%; text-align:center; font-size:12px; line-height:16px; margin-top:5px;">打开手机微信<br>
                  扫一扫继续付款
                </div>
              </div>

              <div class="fl weixn">
                <img src="/assets/img/weixn.png"></div>
            </div>
          </div>
          <div class="banquan">© 1998 - 2018 Tencent Inc. All Rights Reserved</div>
        </div>
      </form>
    </div>

  </div>
</template>
<script>
import Cookies from "js-cookie"
import doPost from "@/pages/Helper/XHR.js"
export default {
    name: 'weixin',
    props: ["showPay","payMoney","payImg","payOrderid"],
    data () {
        return {
            timer: {}
        }
    },
    // props: {
    //     showPay:　{
    //         type: Boolean,
    //         default: false
    //     },
    //     payMoney: {
    //         type: Number,
    //         default: 0
    //     },
    //     payImg: {
    //         type: String
    //     }
    // },
    watch: {
        // showPay () {
        //     console.log(this.showPay)
        // },
        // payMoney () {
        //     console.log(this.payMoney)
        // },
        // payImg () {
          
        // },
        payOrderid () {
            if(this.payOrderid){
                this.timer = setInterval(() => {
                    doPost(
                        {action: 'orderquery',orderid: this.payOrderid},
                        (res) => {
                          if(res.detail && res.status == 0){
                                clearInterval(this.timer)
                               
                                this.$Message.info({
                                    content: res.detail,
                                    duration: 10,
                                    closable: true
                                })
                                let session =  Cookies.get("session")
                                this.$emit('payback')    
                            }
                        }
                    )
                },1500)
            }
        }
    },
    beforeDestroy () {
        clearInterval(this.timer)
    },
    created(){
      
    }
}
</script>


<style>
    .lu_toper {
        width: 100%;
        height: 25px;
        line-height: 25px;
        background: #81878b;
        text-align: right;
        color: #fff;
    }

    .lu_top {
        width: 950px;
        margin: 0 auto;
        font-size: 12px;
    }

    .lu_login {
        width: 100%;
        background: #fff;
        border-bottom: 1px solid #ccc;
        min-height: 60px;
    }

    .lu_log {
        width: 950px;
        margin: 0 auto;
        padding-top: 10px;
    }

    .lu_main {
        width: 950px;
        margin: 0 auto;
        min-height: 500px;
        border-radius: 5px;
        margin-top: 30px;
    }

    .lu_maintop {
        width: 100%;
    }

    .a{
        display: block
    }

    .b{
        display: none
    }

    .lu_main {
        font-size: 14px;
    }

    .fl {
        float: left;
    }

    .fr {
        float: right;
    }

    .clear {
        clear: both;
    }

    .jaige {
        font-size: 30px;
        color: #3cb034;
        font-weight: 600;
        font-family: "微软雅黑";
        margin-top: -20px;
    }

    .lu_mianer {
        width: 950px;
        min-height: 600px;
        background: #fff;
        border-radius: 1px;
        border-top: 3px solid #ccc;
        border-bottom: 3px solid #ccc;
        margin-top: 10px;
    }

    .erweima {
        width: 200px;
        margin-top: 170px;
        text-align: center;
        margin-left: 376px;
        box-shadow:0 0 5px #ccc; padding:10px;
    }

    .weixn {
        margin-left: 20px;
        margin-top: 200px;
    }

    .banquan {
        width: 100%;
        text-align: center;
        font-size: 12px;
        margin-top: 20px;
        color: #808080;
    }
</style>



// WEBPACK FOOTER //
// src/pages/Buy/components/weixin.vue